import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
    getAllroleEmployeesPageable,
    removeRoleToUserByIds,
} from '../../../../../reduxToolkit/EmployeeRoles/EmployeeRolesApi';
import TableFunction from './../../../../../components/table/TableFunction';
import { useTranslation } from 'react-i18next';
import { SEARCH_MODEL } from './../../../../../components/table/Model/TableModel';
import CustomTh from '../../../../../components/table/CustomTh';
import CustomTd from '../../../../../components/table/CustomTd';
import {getFullName} from "../../../../../Apis/functions";
/**
 * @Author: Susana Garcia Rodriguez
 * @JobTitle: Frontend - IBL
 * @Email: sgarcia@ibl.mx
 */
const PrivilegeDetailsApp = (item) => {
    const permission = useSelector((state) => state.authenticatioauthennSlice.permission);
    const DEV = useSelector((state) => state?.CommonsSlice?.development);
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const [searchResults, setSearchResults] = useState('');
    const [selectedList, setSelectedList] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [manageShow, setManageShow] = useState(false);
    const [tableId] = useState('tbl_pdf_department');
    const [modified, setModified] = useState(false);
    const [isAllChecked, setIsAllChecked] = useState(false);

// Generates the table header (only one column for the full name)
    const getThead = () => {
        return [
            <CustomTh tableId={tableId} left={50} classes='first_head'>
                {t('name')}
            </CustomTh>,
        ];
    };

// Generates the table body based on the search results
    const getTbody = () => {
        if (!searchResults || searchResults?.content?.length === 0)
            return {
                body: [],
                data: [],
            };
        let body = searchResults?.content?.map((item, index) => {
            return (
                <>
                    <CustomTd tableId={tableId} left={50} classes={'first-column'}>
                        {getFullName(item?.name, item?.firstLastName, item?.secondLastName)}
                    </CustomTd>
                </>
            );
        });

        return {
            body: body,
            data: searchResults?.content.map((e) => {
                return { ...e, id: e.userId };
            }),
        };
    };

    /**
     * Executes a paginated search request using basic criteria.
     *
     * Builds the request body with the current page, page size, selected model,
     * and any additional criteria passed as arguments.
     * Triggers the search action through Redux and updates the results on success.
     */
    const getData = (page) => {
        const body = SEARCH_MODEL.setObject({ page, size: rowsPerPage, id: item });
        dispatch(getAllroleEmployeesPageable(body)).then(
            ({
                 payload: {
                     data: { data, success },
                 },
             }) => {
                if (success === true) {
                    setSearchResults(data);
                }
            },
        );
    };

// Custom hook that handles table logic: pagination, selection, header and body
    const { handleCheckboxChange, handleDeleteAll, pagination, rowsPerPage, thead, tbody } =
        TableFunction({
            selectedList,
            setSelectedList,
            data: searchResults,
            getThead,
            getTbody,
            labelRowsPerPage: 'users_per_page',
            hasContainer: true,
            fixedPagination: false,
            setIsAllChecked,

            getData,//New
            modified,//New
            setModified//New
        });

    // Deletes selected users from the current role
    const deleteUsers = (deleteItem) => {
        const data = {
            userIds: deleteItem,
            roleId: item,
        };
        dispatch(removeRoleToUserByIds(data)).then(
            ({
                payload: {
                    data: { success },
                },
            }) => {
                if (success) {
                    setIsAllChecked(false);
                    setModified(true);
                    setSelectedList([])
                }
            },
        );
    };

    // Syncs selected list based on the "select all" checkbox state
    useEffect(() => {
        if (isAllChecked && searchResults?.content?.length > 0) {
            const allIds = searchResults.content.map((item) => item?.userId);
            setSelectedList(allIds);
        } else if (!isAllChecked) {
            setSelectedList([]);
        }
    }, [isAllChecked, searchResults]);

    return {
        handleCheckboxChange,
        handleDeleteAll,
        deleteUsers,
        pagination,
        DEV,
        permission,
        thead,
        tbody,
        tableId,
        selectedList,
        setSelectedList,
        modified,
        setModified,
        showModal,
        setShowModal,
        manageShow,
        setManageShow,
        isAllChecked,
        setIsAllChecked,
    };
};

export default PrivilegeDetailsApp;
